import { render, staticRenderFns } from "./CPOColombia.vue?vue&type=template&id=1b99d85a&scoped=true&"
import script from "./CPOColombia.vue?vue&type=script&lang=js&"
export * from "./CPOColombia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99d85a",
  null
  
)

export default component.exports